// extracted by mini-css-extract-plugin
module.exports = {"label":"PasswordInput_label__1cvBH","input":"PasswordInput_input__JaUXt"};